import find from 'lodash/find';
import { sdk } from 'Modules/api';

export default class Interest {
  constructor(User) {
    this.user = User;

    this.currentSavedInterests = [];
  }

  add(interests) {
    if (!interests) {
      return Promise.reject(new ReferenceError('You must pass interests to this method.'));
    }

    const previousRequest = find(this.currentSavedInterests, { interests });
    if (previousRequest) {
      return previousRequest.request;
    }

    const arrayOfInterests = Array.isArray(interests) ? interests : [interests];

    const request = sdk.client.helpers.user.users.addInterests(this.user.id, arrayOfInterests);

    this.currentSavedInterests.push({ request, interests });

    return request;
  }
}
